import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import capitalize from "lodash/capitalize";
import get from "lodash/get";
import React from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";
import { Comments, Doc, Landvision } from "../../../common/js/icons";
import config from "../../../config";
import { aggregateBrokers, booleanToYN, toDollarAmount, toSqft } from "../utils/operations";
import "./Listings.css";

const StyledTableHeaderArea = styled("div")({
    paddingTop: "17px",
});

const StyledPaperPadding = styled("div")({
    padding: "0 20px 20px 20px",
    border: "1px solid #f1f1f1",
    marginBottom: "15px",
});

const StyledPaperHeading = styled("h3")({
    fontSize: "18px",
    margin: "0",
    borderColor: "#f1f1f1",
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
    },
});

const StyledPaperHeading2 = styled("h3")({
    fontSize: "14px",
    margin: "0",
    borderColor: "#f1f1f1",
    fontWeight: 600,
});

const StyledPaperSubHeading = styled("div")({
    fontSize: 12,
});

const StyledHr = styled("hr")({
    margin: "0 0px 20px -20px",
    borderTop: "1px solid #f1f1f1",
});

const StyledDefTerm = styled("span")({
    fontSize: "13px",
    textTransform: "uppercase",
    color: "#9E9E9E",
    fontWeight: 600,
});

const StyledDefData = styled("span")({
    fontSize: "14px",
    color: "#000",
});

const StyledLightButton = styled(Button)({
    fontWeight: "400",
    marginLeft: "0px",
    marginRight: "0px",
});

const StyledLightButtonIcon = styled("span")({
    paddingRight: "3px",
    paddingTop: "6px",
    marginRight: "3px",
});

// Container styles to replace Grid
const StyledFlexContainer = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    flex: "1 1 0",
    margin: "-8px",
});

const StyledFlexRow = styled("div")({
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
});

const StyledFlexColumn = styled("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
});

const StyledButtonContainer = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    marginLeft: "auto",
    justifyContent: "flex-end",
});

const StyledDataGrid = styled("div")({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-evenly",
    width: "100%",
    flexWrap: "wrap",
});

const StyledDataItem = styled("div")({
    flex: "1 0 0",
    margin: "4px 0",
});

const StyledImageContainer = styled("div")({
    width: "100px",
    height: "94px",
    marginTop: "20px",
    backgroundSize: "cover",
    backgroundPosition: "center",
});

const ListingDataPreview = (props) => {
    const {
        canClose,
        currentPath,
        handleCheckboxClick,
        history,
        listing,
        listingTab,
        navigateToRequestUpdate,
        openCloseDealDialog,
        selectedListings,
    } = props;

    const navigateToLandvision = () => {
        ReactGA.event("Navigate To Landvision", {
            property: get(listing, "property.propertyKey"),
        });
        window.open(`${config.LANDVISION_URL}?resource=property&key=${get(listing, "property.propertyKey")}`, "_blank");
    };

    const handleRequestUpdate = () => {
        navigateToRequestUpdate(currentPath);
        history.push(`/listing/${listing.listingKey}`);
    };

    return (
        <StyledPaperPadding>
            <StyledFlexContainer>
                <StyledFlexRow>
                    {listingTab === "broker_open" ? (
                        <StyledImageContainer
                            className="propertySmallImageContainer"
                            style={{
                                backgroundImage: `url(${get(listing, "primaryPhotoUrl", null)})`,
                            }}
                        />
                    ) : (
                        ""
                    )}
                    <StyledTableHeaderArea
                        style={{ paddingTop: "17px", padding: "20px", display: "flex", flexDirection: "column" }}
                    >
                        <StyledFlexColumn style={{ position: "relative" }}>
                            {listingTab === "all_km_listings" && (
                                <div className="listingCheckboxDiv">
                                    <Checkbox
                                        className={
                                            selectedListings[listing.listingKey] === true
                                                ? "listingCheckboxSelected"
                                                : "listingCheckbox"
                                        }
                                        checked={selectedListings[listing.listingKey] === true}
                                        value={selectedListings[listing.listingKey] === true}
                                        onChange={() => handleCheckboxClick(listing.listingKey)}
                                        color="primary"
                                    />
                                </div>
                            )}
                            <Link
                                to={`/listing/${listing.listingKey}`}
                                style={
                                    listing.expired
                                        ? { color: "red", textDecoration: "none" }
                                        : { color: "#000", textDecoration: "none" }
                                }
                            >
                                <StyledPaperHeading
                                    style={listingTab === "all_km_listings" ? { marginLeft: "8px" } : {}}
                                >
                                    {`${get(listing, "listingName", "")}`}
                                </StyledPaperHeading>
                            </Link>
                            <StyledPaperHeading2 style={listingTab === "all_km_listings" ? { marginLeft: "8px" } : {}}>
                                {`No. ${get(listing, "listingKey", "") === null ? "" : get(listing, "listingKey", "")}`}
                            </StyledPaperHeading2>
                        </StyledFlexColumn>
                        <StyledFlexColumn>
                            <StyledPaperSubHeading
                                style={listingTab === "all_km_listings" ? { marginLeft: "8px" } : {}}
                            >
                                {`${
                                    get(listing, "property.primaryAddress.address1") === null
                                        ? ""
                                        : get(listing, "property.primaryAddress.address1")
                                }${get(listing, "property.primaryAddress.city.city") ? ", " : ""}${
                                    get(listing, "property.primaryAddress.city.city") === null
                                        ? ""
                                        : get(listing, "property.primaryAddress.city.city")
                                }${get(listing, "property.primaryAddress.city.state.stateCode") ? ", " : ""}${
                                    get(listing, "property.primaryAddress.city.state.stateCode") === null
                                        ? ""
                                        : get(listing, "property.primaryAddress.city.state.stateCode")
                                }${
                                    get(listing, "property.primaryAddress.zipCode.zipCode", null) !== null ? " • " : ""
                                }${
                                    get(listing, "property.primaryAddress.zipCode.zipCode", null) === null
                                        ? ""
                                        : get(listing, "property.primaryAddress.zipCode.zipCode", null)
                                }`}
                            </StyledPaperSubHeading>
                        </StyledFlexColumn>
                    </StyledTableHeaderArea>
                    <StyledButtonContainer>
                        {listing.flyerUrl && (
                            <StyledLightButton onClick={() => window.open(listing.flyerUrl, "_blank")} color="primary">
                                <span>
                                    <Doc style={{ marginRight: "5px" }} fill="#2C99D2" />
                                </span>
                                Flyer
                            </StyledLightButton>
                        )}
                        <StyledLightButton onClick={handleRequestUpdate} color="primary">
                            <StyledLightButtonIcon>
                                <Comments fill="#2C99D2" />
                            </StyledLightButtonIcon>
                            Request Update
                        </StyledLightButton>

                        <StyledLightButton onClick={() => navigateToLandvision()} color="primary">
                            <span style={{ marginRight: "5px" }}>
                                <Landvision fill="#2C99D2" />
                            </span>
                            LandVision
                        </StyledLightButton>

                        {listing.nonKmListingFlg !== true && canClose && (
                            <Button variant="contained" color="primary" onClick={() => openCloseDealDialog(listing)}>
                                Close Deal
                            </Button>
                        )}
                    </StyledButtonContainer>
                </StyledFlexRow>
            </StyledFlexContainer>

            {listingTab === "broker_open" ? (
                <div></div>
            ) : (
                <React.Fragment>
                    <StyledHr />
                    <StyledDataGrid>
                        <StyledDataItem>
                            <StyledDefTerm>Date Avail</StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>{listing.dateAvailable}</StyledDefData>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefTerm>SF Div</StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>
                                {listing.listingType === "Sale" ? "N/A" : toSqft(get(listing, "sfDivisibleTo"))}
                            </StyledDefData>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefTerm>
                                {listing.listingType === "Sale" ? "List Price" : "Monthly Rate"}
                            </StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>
                                {listing.listingType === "Sale"
                                    ? `${toDollarAmount(get(listing, "listPrice", ""))}`
                                    : `${toDollarAmount(get(listing, "askingRentMax", ""))}`}
                            </StyledDefData>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefTerm>{listing.listingType === "Sale" ? "Floors" : "Annual Rate"}</StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>
                                {listing.listingType === "Sale"
                                    ? `${get(listing, "floor", "")}`
                                    : `${toDollarAmount(get(listing, "askingRentMax", "") * 12)}`}
                            </StyledDefData>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefTerm>Broker</StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>
                                {get(listing, "listingAgent", null) !== null
                                    ? get(listing, "listingAgent", null)
                                    : aggregateBrokers(get(listing, "listingBrokers", []), "brokerAgentKey.person")}
                            </StyledDefData>
                        </StyledDataItem>
                    </StyledDataGrid>
                    <StyledDataGrid>
                        <StyledDataItem>
                            <StyledDefTerm>Type</StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>
                                {get(listing, "attributes.useType", null) !== null
                                    ? `${capitalize(get(listing, "attributes.useType"))} ${capitalize(
                                          listing.listingType
                                      )}`
                                    : capitalize(listing.listingType)}
                            </StyledDefData>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefTerm>{listing.listingType === "Sale" ? "Sale SF" : "SF Avail"}</StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>{toSqft(get(listing, "sfAvail"))}</StyledDefData>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefTerm>NNN Rate</StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>{toDollarAmount(get(listing, "monthlyCamNNN"))}</StyledDefData>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefTerm>Sublet</StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>{booleanToYN(listing.subleaseFlg)}</StyledDefData>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefTerm>Company</StyledDefTerm>
                        </StyledDataItem>
                        <StyledDataItem>
                            <StyledDefData>
                                {get(listing, "listingCompany", null) !== null
                                    ? get(listing, "listingCompany", "")
                                    : get(listing, "listingBrokers[0].brokerAgentKey.person.company.displayName")}
                            </StyledDefData>
                        </StyledDataItem>
                    </StyledDataGrid>
                </React.Fragment>
            )}
        </StyledPaperPadding>
    );
};

export default ListingDataPreview;
